import React from "react";
import { useLang } from "../lib/i18n";
import { Languages } from "lucide-react";

export default function LanguageSwitcher({ compact = false }) {
  const { lang, setLang } = useLang();
  return (
    <div
      role="group"
      aria-label="Language"
      className={`inline-flex items-center gap-0.5 bg-white border border-[#E8E6E1] rounded-full p-1 ${compact ? "text-xs" : "text-sm"}`}
      data-testid="lang-switcher"
    >
      {!compact && <Languages className="w-4 h-4 text-[#8A8D91] ml-2 mr-1" />}
      <button
        onClick={() => setLang("en")}
        data-testid="lang-en"
        aria-pressed={lang === "en"}
        className={`px-3 py-1 rounded-full font-medium transition-colors ${
          lang === "en" ? "bg-[#3D405B] text-white" : "text-[#3D405B] hover:bg-[#F4F1DE]"
        }`}
      >
        EN
      </button>
      <button
        onClick={() => setLang("fr")}
        data-testid="lang-fr"
        aria-pressed={lang === "fr"}
        className={`px-3 py-1 rounded-full font-medium transition-colors ${
          lang === "fr" ? "bg-[#3D405B] text-white" : "text-[#3D405B] hover:bg-[#F4F1DE]"
        }`}
      >
        FR
      </button>
    </div>
  );
}
